var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.172735,195.197802 C211.105735,148.267399 288.820482,148.267399 336.75348,195.197802 L342.522294,200.845951 C344.918944,203.192471 344.918944,206.996932 342.522294,209.343453 L322.788333,228.664646 C321.590008,229.837907 319.647139,229.837907 318.448814,228.664646 L310.510241,220.892121 C277.070983,188.152299 222.855233,188.152299 189.415974,220.892121 L180.914419,229.215854 C179.716093,230.389114 177.773224,230.389114 176.5749,229.215854 L156.840939,209.894661 C154.444289,207.54814 154.444289,203.743679 156.840939,201.397159 L163.172735,195.197802 Z M377.565175,235.156072 L395.128438,252.352031 C397.525076,254.69854 397.52509,258.502978 395.128469,260.849503 L315.934501,338.388214 C313.537868,340.734752 309.652131,340.734778 307.255464,338.388275 C307.255454,338.388265 307.255443,338.388254 307.255433,338.388244 L251.048373,283.356763 C250.449211,282.770133 249.477776,282.770133 248.878614,283.356763 C248.87861,283.356767 248.878607,283.356771 248.878603,283.356774 L192.67274,338.388214 C190.276114,340.734758 186.390376,340.734797 183.993702,338.3883 C183.993688,338.388286 183.993673,338.388272 183.993658,338.388257 L104.797487,260.848515 C102.400838,258.501995 102.400838,254.697534 104.797487,252.351014 L122.360782,235.155084 C124.757431,232.808564 128.643169,232.808564 131.039819,235.155084 L187.247697,290.187334 C187.84686,290.773964 188.818293,290.773964 189.417456,290.187334 C189.417465,290.187325 189.417473,290.187317 189.417482,290.18731 L245.622543,235.155084 C248.019138,232.80851 251.904876,232.808422 254.301581,235.154888 C254.301614,235.154921 254.301647,235.154954 254.30168,235.154987 L310.509484,290.18731 C311.108646,290.773939 312.080081,290.773939 312.679243,290.18731 L368.886138,235.156072 C371.282788,232.809551 375.168525,232.809551 377.565175,235.156072 Z",
    fill: "#3B99FC",
    fillRule: "nonzero"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.337331cdfa0561cd01f112d4440d936c.svg";
export { ForwardRef as ReactComponent };